import { render } from "./Detail.vue?vue&type=template&id=0c27c3ae&scoped=true"
import script from "./Detail.vue?vue&type=script&lang=js"
export * from "./Detail.vue?vue&type=script&lang=js"

import "./Detail.vue?vue&type=style&index=0&id=0c27c3ae&lang=scss&scoped=true"

import exportComponent from "/var/www/legalculture.ru/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c27c3ae"]])

export default __exports__